import { GraphQLError } from 'graphql';

import { includes } from '../helpers/guards';

const AUTHENTICATION_ERROR_MESSAGE = 'Authentication failed!';
const AUTHORIZATION_HYPERION_ERROR_MESSAGE = 'Requires authentication!'; // https://github.com/hoverinc/hyperion/blob/9a5aa7cdf485d65db9db8f63953a5e76a5a96de6/app/graphql/graph_ql_mixins/current_user.rb#L8
const AUTHORIZATION_OTHER_ERROR_MESSAGE = 'Must be authenticated'; // https://github.com/hoverinc/ehi-api/blob/70fa74c3c98429069d23adc52bc3d07adc5fc0bf/app/graphql/graph_ql_mixins/authorization.rb#L4

const AUTHORIZATION_ERROR_MESSAGES = [
  AUTHORIZATION_HYPERION_ERROR_MESSAGE,
  AUTHORIZATION_OTHER_ERROR_MESSAGE,
] as const;

const HANDLED_ERRORS = [
  AUTHENTICATION_ERROR_MESSAGE,
  ...AUTHORIZATION_ERROR_MESSAGES,
] as const;

const isAuthorizationError = ({ message }: GraphQLError | Error) =>
  includes(AUTHORIZATION_ERROR_MESSAGES, message);

const isHandledError = ({ message }: GraphQLError | Error) =>
  includes(HANDLED_ERRORS, message);

export {
  AUTHENTICATION_ERROR_MESSAGE,
  AUTHORIZATION_ERROR_MESSAGES,
  HANDLED_ERRORS,
  isAuthorizationError,
  isHandledError,
};
